<app-navigation></app-navigation>
<router-outlet></router-outlet>

<app-common-dialogs></app-common-dialogs>

<app-notification-panel></app-notification-panel>
